/**
 * <sp-abone-penceresi> E-posta abone penceresi.
 * Açılma: sayfanın data-kaydirma yüzdesine inince ya da data-gecikme saniye sonra (hangisi önce olursa).
 * Kapatınca data-tekrar-gun gün boyunca açılmaz; kayıt olunca (bu pencereden ya da alt bilgideki formdan)
 * bir daha hiç açılmaz. Kayıt sonrası sayfa yeniden yüklendiğinde pencere teşekkür mesajıyla açılır.
 * [data-sp-abone-ac] düğmesi ya da "#sp-abone" bağlantısı pencereyi beklemeden açar.
 */

const SP_ABONE_ANAHTAR = 'sp-abone';
const SP_KAPATMA_ANAHTAR = 'sp-abone-kapatildi';

function spOku(anahtar) {
  try {
    return localStorage.getItem(anahtar);
  } catch {
    return null;
  }
}

function spYaz(anahtar, deger) {
  try {
    localStorage.setItem(anahtar, deger);
  } catch {
    /* tarayıcı depolamayı engelliyor; pencere yine çalışır */
  }
}

class SpAbonePenceresi extends HTMLElement {
  connectedCallback() {
    this.kutu = this.querySelector('.sp-abp__kutu');
    const basarili = this.querySelector('[data-sp-abp-basarili]');
    const hata = this.querySelector('[data-sp-abp-hata]');
    const gonderildi = new URLSearchParams(location.search).get('customer_posted') === 'true';

    if (basarili || gonderildi) spYaz(SP_ABONE_ANAHTAR, '1');

    // Kayıt bu pencereden yapıldıysa sonucu (teşekkür ya da hata) göstermek için hemen aç
    let buradanGonderildi = false;
    try {
      buradanGonderildi = sessionStorage.getItem('sp-abone-gonderdi') === '1';
      sessionStorage.removeItem('sp-abone-gonderdi');
    } catch {
      /* depolama kapalı */
    }
    // Kontrol için: adrese ?abone-test eklenince sayaç beklenmeden açılır, hatırlama yok sayılır
    const test = new URLSearchParams(location.search).has('abone-test');
    if (test || (buradanGonderildi && (basarili || hata))) {
      this.ac();
      return;
    }

    if (spOku(SP_ABONE_ANAHTAR)) return;
    const kapatildi = Number(spOku(SP_KAPATMA_ANAHTAR) || 0);
    const tekrarGun = Number(this.dataset.tekrarGun || 7);
    if (kapatildi && Date.now() - kapatildi < tekrarGun * 86400000) return;

    const gecikme = Number(this.dataset.gecikme || 15) * 1000;
    const kaydirma = Number(this.dataset.kaydirma || 50) / 100;

    this.zamanlayici = setTimeout(() => this.ac(), gecikme);
    this.kaydir = () => {
      const yukseklik = document.documentElement.scrollHeight - window.innerHeight;
      if (yukseklik > 0 && window.scrollY / yukseklik >= kaydirma) this.ac();
    };
    window.addEventListener('scroll', this.kaydir, { passive: true });
  }

  disconnectedCallback() {
    this.temizle();
  }

  temizle() {
    clearTimeout(this.zamanlayici);
    if (this.kaydir) window.removeEventListener('scroll', this.kaydir);
    this.kaydir = null;
  }

  ac() {
    this.temizle();
    if (this.acik) return;
    // Başka bir çekmece ya da pencere açıksa üstüne binme; birazdan tekrar dene
    if (document.querySelector('dialog[open], .cart-drawer[open], details[open].menu-drawer-container')) {
      this.zamanlayici = setTimeout(() => this.ac(), 5000);
      return;
    }
    this.acik = true;
    this.oncekiOdak = document.activeElement;
    this.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-acik')));
    this.kutu?.focus({ preventScroll: true });

    this.kapatTiklama = (olay) => {
      if (olay.target.closest('[data-sp-abp-kapat]')) this.kapat();
    };
    this.tus = (olay) => {
      if (olay.key === 'Escape') this.kapat();
    };
    this.addEventListener('click', this.kapatTiklama);
    const kopyala = this.querySelector('[data-sp-abp-kopyala]');
    kopyala?.addEventListener('click', async () => {
      const kod = this.querySelector('[data-sp-abp-kod]')?.textContent.trim();
      try {
        await navigator.clipboard.writeText(kod);
        kopyala.textContent = 'Kopyalandı';
      } catch {
        kopyala.textContent = 'Kodu seçip kopyala';
      }
    });
    document.addEventListener('keydown', this.tus);
    this.querySelector('form')?.addEventListener('submit', () => {
      try {
        sessionStorage.setItem('sp-abone-gonderdi', '1');
      } catch {
        /* depolama kapalı */
      }
    });
  }

  kapat() {
    if (!spOku(SP_ABONE_ANAHTAR)) spYaz(SP_KAPATMA_ANAHTAR, String(Date.now()));
    this.classList.remove('is-acik');
    this.removeEventListener('click', this.kapatTiklama);
    document.removeEventListener('keydown', this.tus);
    setTimeout(() => {
      this.hidden = true;
      this.acik = false;
    }, 400);
    if (this.oncekiOdak?.focus) this.oncekiOdak.focus({ preventScroll: true });
  }
}

if (!customElements.get('sp-abone-penceresi')) customElements.define('sp-abone-penceresi', SpAbonePenceresi);

// Sayfadaki [data-sp-abone-ac] düğmeleri ve "#sp-abone" bağlantıları (ör. duyuru bandı) pencereyi hemen açar.
document.addEventListener('click', (olay) => {
  const acici = olay.target.closest('[data-sp-abone-ac], a[href$="#sp-abone"]');
  if (!acici) return;
  const pencere = document.querySelector('sp-abone-penceresi');
  if (!pencere) return;
  olay.preventDefault();
  pencere.ac();
});
